import { makeAdSupportedGamePolicy } from './game-ads'

/** Bargainsmith — 흥정 덱빌더. 무료 + AdMob 광고 + 광고 제거 인앱결제. */
export const BARGAINSMITH_POLICY = makeAdSupportedGamePolicy({
  slug: 'bargainsmith',
  title: 'Bargainsmith Privacy Policy',
  name: 'Bargainsmith',
  storedOnDevice:
    'How many runs you have played and won, the furthest round you have reached, which card you kept from your last winning run, whether you bought the ad removal, and your sound and music volume are the only things the app keeps.',
  removeAdsProductId: 'com.cottonray.bargainsmith.remove_ads',
  effectiveDate: 'August 25, 2026',
  history: [
    'August 25, 2026 — established (structured on Article 30 of the Personal Information Protection Act, including notice of transfers abroad), covering advertising through Google AdMob (a banner in a reserved strip along the bottom while you play and one interstitial when a game ends) and the one-off in-app purchase that removes them. The game requests network access for those two things only',
  ],
})
